import { render, staticRenderFns } from "./qs2-01.vue?vue&type=template&id=913b1538&"
import script from "./qs2-01.vue?vue&type=script&lang=js&"
export * from "./qs2-01.vue?vue&type=script&lang=js&"
import style0 from "./qs2-01.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports